import { forwardRef } from 'react'
import { Modal } from '@mui/material'
import { MiteneFormattedMessage } from 'components/atoms/MiteneFormattedMessage'
import { MitenePaper } from 'components/molecules/MitenePaper/MitenePaper'
import styles from './FullScreenModal.module.scss'

export type Props = {
  isOpen: boolean;
}

export const FullScreenModal = ({ isOpen }: Props) => (
  <Modal open={isOpen} BackdropProps={{ className: styles.backdrop }} >
    <RefMitenePaper />
  </Modal >
)

const RefMitenePaper = forwardRef<HTMLDivElement>(
  (_, ref) => (
    <MitenePaper title={title()} body={body()} tabIndex={-1} forwardRef={ref} />
  )
)

const title = () => (
  <MiteneFormattedMessage id='fullscreenmodal.notSupportedBrowser.title' />
)

const body = () => (
  <MiteneFormattedMessage id='fullscreenmodal.notSupportedBrowser.body' />
)
